var _a, _b, _c, _d, _e;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpaceLabelService } from '@/domains/spaces/services/space-label-service.interface';
import { ShareSpaceModel } from '@/domains/share-space/models/share-space-model';
import { ShareSpaceDialogService } from './share-space-dialog-service.interface';
import { CurrentSpaceService } from '@/domains/spaces/services/current-space-service.interface';
import { RavenService } from '@cores/modules/raven-module/raven-service';
let SharePublicSpaceCommandContribution = class SharePublicSpaceCommandContribution {
    constructor(_shareSpaceDialogService, _spaceLabelService, _shareSpaceModel, _currentSpaceService, _ravenService) {
        this._shareSpaceDialogService = _shareSpaceDialogService;
        this._spaceLabelService = _spaceLabelService;
        this._shareSpaceModel = _shareSpaceModel;
        this._currentSpaceService = _currentSpaceService;
        this._ravenService = _ravenService;
    }
    registerCommands(commandRegistry) {
        commandRegistry.registerCommand({
            id: 'share-public-space',
        }, {
            execute: () => {
                this._ravenService.track('Click Share Workspace', {
                    other_param: 'public space action menu',
                });
                const space = this._currentSpaceService.getCurrentSpace();
                this._shareSpaceModel.update(modelData => {
                    modelData.spaceType = space.spaceType;
                    modelData.spaceId = space.spaceId;
                    modelData.spaceName = space.spaceName;
                    modelData.spaceS3Key = space.iconImageUrl;
                    modelData.spaceIcon = space.buildInIconId;
                    modelData.enableShareSpace = true;
                    return modelData;
                });
                return this._shareSpaceDialogService.open().finally(() => {
                    this._spaceLabelService.resetSpaceLabel();
                });
            },
        });
    }
};
SharePublicSpaceCommandContribution = __decorate([
    injectable(),
    __param(0, inject(ShareSpaceDialogService)),
    __param(1, inject(SpaceLabelService)),
    __param(2, inject(ShareSpaceModel)),
    __param(3, inject(CurrentSpaceService)),
    __param(4, inject(RavenService)),
    __metadata("design:paramtypes", [typeof (_a = typeof ShareSpaceDialogService !== "undefined" && ShareSpaceDialogService) === "function" ? _a : Object, typeof (_b = typeof SpaceLabelService !== "undefined" && SpaceLabelService) === "function" ? _b : Object, typeof (_c = typeof ShareSpaceModel !== "undefined" && ShareSpaceModel) === "function" ? _c : Object, typeof (_d = typeof CurrentSpaceService !== "undefined" && CurrentSpaceService) === "function" ? _d : Object, typeof (_e = typeof RavenService !== "undefined" && RavenService) === "function" ? _e : Object])
], SharePublicSpaceCommandContribution);
export { SharePublicSpaceCommandContribution };
